import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Silent session refresh: on a 401, try /auth/refresh once (using the long-lived
// refresh cookie) and replay the original request. Fixes "Not authenticated" once
// the 15-minute access token expires during an active session.
let refreshPromise = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    const url = original.url || "";
    const isAuthFlow = url.includes("/auth/refresh") || url.includes("/auth/login") || url.includes("/auth/logout");
    if (status === 401 && !original._retry && !isAuthFlow) {
      original._retry = true;
      try {
        if (!refreshPromise) refreshPromise = api.post("/auth/refresh").finally(() => { refreshPromise = null; });
        await refreshPromise;
        return api(original);
      } catch (e) {
        const PUBLIC = ["/login", "/apply", "/offer", "/contract", "/onboarding", "/portal", "/reset-password", "/set-password", "/forgot-password"];
        const path = typeof window !== "undefined" ? window.location.pathname : "";
        if (typeof window !== "undefined" && !PUBLIC.some((p) => path.startsWith(p))) {
          window.location.href = "/login";
        }
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail === "object") {
    if (typeof detail.msg === "string") return detail.msg;
    if (Array.isArray(detail.errors)) return detail.errors.join(" ");
    return JSON.stringify(detail);
  }
  return String(detail);
}

export const fmtHours = (h) =>
  h === null || h === undefined ? "—" : `${Number(h).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}h`;

export const fmtDate = (d) => {
  if (!d) return "—";
  try {
    const dt = new Date(d);
    const day = String(dt.getDate()).padStart(2, "0");
    const mon = String(dt.getMonth() + 1).padStart(2, "0");
    const yr = String(dt.getFullYear()).slice(-2);
    return `${day}-${mon}-${yr}`;
  } catch { return d; }
};

export default api;
